import { create } from 'zustand';
import { toast } from 'sonner';

// Every sticky desk popup (new-lead / assignment / duplicate cards, 15-minute
// appointment reminders) registers here with its acknowledge callback, so the
// one "Dismiss all" pill clears the whole top-right stack. Radiance 260924:
// the pill only knew about the lead cards and left the appointment reminder
// behind.
const acknowledgers = new Map<string | number, () => void>();

interface PopupStackState {
  count: number;
  track: (id: string | number, acknowledge: () => void) => void;
  untrack: (id: string | number) => void;
  dismissAll: () => void;
}

export const usePopupStackStore = create<PopupStackState>((set) => ({
  count: 0,

  track: (id, acknowledge) => {
    acknowledgers.set(id, acknowledge);
    set({ count: acknowledgers.size });
  },

  untrack: (id) => {
    acknowledgers.delete(id);
    set({ count: acknowledgers.size });
  },

  dismissAll: () => {
    acknowledgers.forEach((acknowledge, id) => {
      acknowledge();
      toast.dismiss(id);
    });
    acknowledgers.clear();
    set({ count: 0 });
  },
}));
